/* eslint-disable no-unused-expressions */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Col, FormGroup, Input, Label, Row } from 'reactstrap';
import publicIp from 'react-public-ip';
import moment from 'moment';

import CustomModal from '../../CustomModal';
import CustomWarning from '../../CustomWarning';
import './ActivateButton.css';
import {
  addNote,
  getEpikBoxData,
  portChecklist,
  saveCheckList,
  selectBoxDetailsObi,
} from '../../../actions/EpikBoxes';
import SpinnerCircles from '../../Spinner/SpinerCircles';
import Toggle from '../../Toggle';
import utils from '../../../lib/utils';
import { dialToneOnly } from '../constants';

let checkListCount = 0;
const ActivateButton = ({ port, disabled = false }) => {
  const token = localStorage.getItem('jwtToken') || null;

  const dispatch = useDispatch();

  const userDetail = useSelector(state => state.AppState.user);
  const boxDetails = useSelector(state => state.AppState.boxDetails.box);

  const [dialToneOnlyChecked, setDialToneOnlyChecked] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [signedStatus, setSignedStatus] = useState(false);
  const [startBilling, setStartBilling] = useState(false);
  const [signedModal, setSignedModal] = useState({ status: false, modalType: '' });
  const [loading, setLoading] = useState(false);
  const [selectedObiId, setSelectedObiId] = useState(null);
  const [saveLoading, setSaveLoading] = useState(false);
  const [activateLoading, setActivateLoading] = useState(false);
  const [checkList, setCheckList] = useState(null);
  const [checkListData, setCheckListData] = useState(null);
  const [localIpAddress, setLocalIpAddress] = useState('');
  const [checkListChecked, setCheckListChecked] = useState(true);
  const [activateBtnColor, setActivateBtnColor] = useState(
    port.portActivated ? `success` : `primary`,
  );
  const [activateBtnText, setActivateBtnText] = useState(
    port.portActivated ? `Activated` : `Activate`,
  );
  const [portActivateBtnText, setPortActivateBtnText] = useState(
    port.portActivated ? `Activated` : `Activate Port`,
  );

  const selectedObi = async () => {
    const foundObi = boxDetails.Obis.find(obi => {
      return (
        (obi.port1 && obi.port1.boxPortNumber === port.boxPortNumber) ||
        (obi.port2 && obi.port2.boxPortNumber === port.boxPortNumber)
      );
    });
    setSelectedObiId(foundObi?._id);
    if (foundObi) {
      await dispatch(selectBoxDetailsObi(foundObi));
    }
  };

  const onActivateButton = async () => {
    setSignedStatus(false);
    setLoading(true);
    setPortActivateBtnText(<SpinnerCircles />);
    const portType = port?.assignedNumberRef?.type || port.serviceName;
    const checklist = await dispatch(
      portChecklist(token, boxDetails._id, portType, port.boxPortNumber),
    );
    setActivateBtnText(checklist?.isPortActivated ? `Activated` : `Activate`);
    setPortActivateBtnText(checklist?.isPortActivated ? `Activated` : `Activate Port`);
    setActivateBtnColor(checklist?.isPortActivated || port.portActivated ? `success` : `primary`);
    setCheckListData(checklist);
    checkListCount = 0;
    checklist?.checklistItems?.forEach(item => {
      if (item.isChecked) checkListCount += 1;
    });
    setDialToneOnlyChecked(checklist?.checklistItems?.some(item => item.item === 'Dial Tone Only' && item.isChecked));
    const allCheckedExceptDialToneOnly = checklist?.checklistItems?.every(item => item.item === 'Dial Tone Only' || item.isChecked);
    setCheckListChecked(!(checklist?.checklistItems?.some(item => item.item === 'Dial Tone Only' && item.isChecked) || allCheckedExceptDialToneOnly));
    setStartBilling(checklist?.hasBilling?.isChecked || false);
    setCheckList(checklist?.checklistItems);
    setLoading(false);
    setIsOpen(true);
  };

  const onCheckboxChange = ev => {
    const { name, checked } = ev.target;

    if (name === 'Dial Tone Only') {
      setDialToneOnlyChecked(checked);

      // Uncheck all other items if "Dial Tone Only" is checked
      const newCheckList = checkList.map(item => ({
        ...item,
        isChecked: item.item === 'Dial Tone Only' ? checked : false,
      }));

      checkListCount = checked ? 1 : 0;
      setCheckList(newCheckList);
      setCheckListChecked(checked ? false : checkListCount !== newCheckList.length);
      return;
    }

    const newCheckList = checkList.map(item => {
      if (item.item === name) {
        checkListCount = !item.isChecked ? checkListCount + 1 : checkListCount - 1;
        return { ...item, isChecked: !item.isChecked };
      }
      return item;
    });

    // setCheckListChecked(checkListCount !== checkList.length);
    setCheckList(newCheckList);
    // Update button enable status
    const allCheckedExceptDialToneOnly = !dialToneOnlyChecked && newCheckList.every(item => item.item === 'Dial Tone Only' || item.isChecked);
    setCheckListChecked(!allCheckedExceptDialToneOnly);
  };

    // Function to fetch updated port status
    const fetchPortStatus = async () => {
      const portType = port?.assignedNumberRef?.type || port.serviceName;
      const checklist = await dispatch(
        portChecklist(token, boxDetails._id, portType, port.boxPortNumber),
      );
  
      // Update state with the latest activation status
      setActivateBtnText(checklist?.isPortActivated ? 'Activated' : 'Activate Port');
      setPortActivateBtnText(checklist?.isPortActivated ? 'Activated' : 'Activate Port');
      setActivateBtnColor(checklist?.isPortActivated ? 'success' : 'primary');
    };
    // useEffect to fetch data when component render or port activation status changes
    useEffect(() => {
      fetchPortStatus();
    }, [port]);

  useEffect(() => {
    const getIpAddress = async () => {
      const ipv4 = (await publicIp.v4()) || '';
      setLocalIpAddress(ipv4);
    };
    getIpAddress();
    selectedObi();
  }, []);

  const activatePayload = status => {
    const portType = port?.assignedNumberRef?.type || port.serviceName;
    const portNumber = port.boxPortNumber;
    const ipAddress = localIpAddress;
    const number = port?.assignedNumberRef?._id;
    const id = checkListData?.id;

    const newObject = checkList?.reduce((acc, item) => {
      if (item.item?.includes('.')) {
        const newKey = item.item?.replace('.', 'xxx');
        return { ...acc, [newKey]: item.isChecked };
      }
      return { ...acc, [item.item]: item.isChecked };
    }, {});
    const body = {
      ...newObject,
      ipAddress,
      portType,
      port: portNumber,
      number,
      id,
      status,
      ATAID: selectedObiId,
      hasBilling: status === 'Activate' ? true : startBilling,
    };
    return body;
  };

  const onSaveProgress = async () => {
    setSignedModal({ status: true, modalType: 'saveProgress' });
  };

  const onActivateBox = async () => {
    setSignedModal({ status: true, modalType: 'activate' });
  };

  const activateSignedBox = async () => {
    setActivateLoading(true);
    const onActivate = await dispatch(
      saveCheckList(token, boxDetails._id, activatePayload('Activate')),
    );
    await dispatch(getEpikBoxData(token, boxDetails._id));
    if (onActivate?.checklistItems) {
      const noteBody = {
        note: `${port.boxPortNumber} Activated for Billing.`,
        type: 'system',
        file: '',
      };
      await dispatch(addNote(token, boxDetails._id, noteBody));
      setCheckListData(onActivate);
    }
    setActivateBtnColor(onActivate?.isPortActivated || port.portActivated ? `success` : `primary`);
    setActivateBtnText(onActivate?.isPortActivated ? `Activated` : `Activate`);
    let portActivationButtonText = `Activate Port`;
    if (loading) {
      portActivationButtonText = <SpinnerCircles />;
    } else {
      portActivationButtonText = onActivate?.isPortActivated ? 'Activated' : 'Activate Port';
    }
    setPortActivateBtnText(portActivationButtonText);
    setActivateLoading(false);
    setIsOpen(false);
    setSignedModal({ status: false, modalType: '' });
  };

  const saveSignedProgress = async () => {
    setSaveLoading(true);
    const result = await dispatch(saveCheckList(token, boxDetails._id, activatePayload('Save')));
    if (result?.checklistItems) {
      await dispatch(getEpikBoxData(token, boxDetails._id));
      setCheckListData(result);
      setCheckList(result?.checklistItems);
    }
    setSaveLoading(false);
    setSignedModal({ status: false, modalType: '' });
  };

  return (
    <>
      <Button
        loading={loading}
        color={activateBtnColor}
        style={{ marginRight: '10px' }}
        onClick={onActivateButton}
        disabled={disabled}
      >
        {portActivateBtnText}
      </Button>
      <CustomModal
        header="Post Activation Checklist"
        saveLoading={saveLoading}
        isOpen={isOpen}
        close
        onConfirm={onActivateBox}
        onSave={onSaveProgress}
        saveBtnText="Save Progress"
        onCancel={() => setIsOpen(false)}
        customButtonText="Ok"
        confirmBtnText={activateBtnText}
        loading={activateLoading}
        confirmDisabled={checkListChecked}
        customButtomColor={activateBtnColor}
      >
        <Row>
          <Col md={10} style={{ margin: 'auto' }}>
            <FormGroup style={{ marginLeft: '20px', display: 'flex', flexDirection: 'column' }}>
              {checkList?.map(item => (
                <Label className="mb-2" check key={item.item}>
                  <Input
                    type="checkbox"
                    name={item.item}
                    checked={item.isChecked}
                    onChange={ev => onCheckboxChange(ev)}
                    disabled={(dialToneOnlyChecked || port?.serviceName == dialToneOnly) && item.item !== 'Dial Tone Only'}
                  />
                  <span style={{ color: (dialToneOnlyChecked || port?.serviceName == dialToneOnly) && item.item !== 'Dial Tone Only' ? 'grey' : 'black' }}>
                    {item?.item?.includes('xxx') ? item?.item?.replace('xxx', '.') : item?.item}
                  </span>
                  <span className="completed-text">
                    {item.user
                      ? `${'     '}[Completed on ${utils.getDateTimeFormat(item?.timeStamp, 'both')} by ${item?.user}]`
                      : null}
                  </span>
                </Label>
              ))}
              {/* Commenting this code for future use. */}
              {/* <div className="mt-3">
                <p className="font-weight-bold">Billing Exception</p>
                <Row className="mb-2">
                  <Col md={8} className="d-flex align-item-start">
                    <Toggle
                      greenSides
                      right="Start Billing"
                      value={startBilling}
                      onToggle={() => setStartBilling(!startBilling)}
                    />
                  </Col>
                  <Col md={4}>
                    <span className="completed-text">
                      {checkListData?.hasBilling?.user
                        ? `${'     '}[Completed on ${moment(
                            checkListData?.hasBilling?.timeStamp,
                          ).format('MM/DD/YYYY hh:mm A')} by ${checkListData?.hasBilling?.user}]`
                        : null}
                    </span>
                  </Col>
                </Row>
              </div> */}
            </FormGroup>
          </Col>
        </Row>
      </CustomModal>
      <CustomWarning
        loading={activateLoading || saveLoading}
        isOpen={signedModal.status}
        onCancel={() => setSignedModal({ status: false, modalType: '' })}
        onConfirm={() => {
          if (signedModal.modalType === 'saveProgress') {
            saveSignedProgress();
          } else if (signedModal.modalType === 'activate') {
            activateSignedBox();
          }
        }}
        customText="Sign"
      >
        I certify that the above actions have been completed and this port has been tested and
        approved for
        <b>{` ${port?.assignedNumberRef?.type || port.serviceName} `}</b>
        Use.
        {startBilling && checkListChecked ? (
          <>
            <p className="font-weight-bold mt-3">Billing Exception</p>
            <p>
              By Clicking the start billing checkbox, this port will be initialized for billing
              regardless of whether the port activation checklist is complete.
            </p>
          </>
        ) : null}
      </CustomWarning>
    </>
  );
};
export default ActivateButton;
